import "@/App.css";
import { useEffect, lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ScrollToTop from "@/components/ScrollToTop";

// Lazy load page components
const HomePage = lazy(() => import("@/pages/HomePage"));
const ArticlePage = lazy(() => import("@/pages/ArticlePage"));
const CategoryPage = lazy(() => import("@/pages/CategoryPage"));
const AdminPage = lazy(() => import("@/pages/AdminPage"));
const ContactPage = lazy(() => import("@/pages/ContactPage"));
const TermsPage = lazy(() => import("@/pages/TermsPage"));
const PrivacyPage = lazy(() => import("@/pages/PrivacyPage"));
const AboutPage = lazy(() => import("@/pages/AboutPage"));
const CompetitionsPage = lazy(() => import("@/pages/CompetitionsPage"));

const TagPage = lazy(() => import("@/pages/TagPage"));
const NotFound = lazy(() => import("@/pages/NotFound"));

const CanonicalManager = () => {
  const location = useLocation();

  useEffect(() => {
    const canonical = document.querySelector("link[rel='canonical']");
    if (canonical) {
      canonical.href = `https://koranews24.com${location.pathname}`;
    }
  }, [location]);

  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <CanonicalManager />
        <Suspense fallback={
          <div className="min-h-screen bg-[#0a0f1d] flex items-center justify-center">
            <div className="w-12 h-12 border-4 border-[#c9a227] border-t-transparent rounded-full animate-spin"></div>
          </div>
        }>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/article/:id" element={<ArticlePage />} />
            <Route path="/competitions" element={<CompetitionsPage />} />
            <Route path="/category/:slug" element={<CategoryPage />} />
            <Route path="/tag/:tagName" element={<TagPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
